import React, {useState} from 'react'
import { marked } from 'marked';
import { useDashboardContext } from '../../../context/DashboardContext';


const CompetitorCard = ({ secCode, companyName, description }) => {
    const [showFullSentence, setShowFullSentence] = useState(false);
    const { dispatch: dashboardDispatch } = useDashboardContext();
    

    const descriptionHtml = marked(description);

    const handleShowMore = () => {
        setShowFullSentence(!showFullSentence)
    }

    const onCompanyNameClick = (secCode) => {
        console.log(secCode)
        dashboardDispatch({type: 'SET_SEC_CODE', payload: secCode})
    }

    return (
        <div className={`competitor-card ${showFullSentence ? "height-auto": ""}`}>
            <span className="similar-company-name text-xl text-gray-600 font-bold cursor-pointer rounded-full px-4 py-1" onClick={() => onCompanyNameClick(secCode)}>{companyName}</span>
            <div className={`company-description-div ${showFullSentence ? "height-auto": ""}`} dangerouslySetInnerHTML={{ __html: descriptionHtml }}>
            </div>
            <div className="show-more" onClick={handleShowMore}>{showFullSentence ? "Hide" : "Show More"}</div>
        </div>
    )
}

export default CompetitorCard